import { useLanguage } from '@/contexts/LanguageContext';
import { HiroMark } from '@/components/brand/HiroMark';

/** @deprecated Import from `@/components/brand/HiroMark` */
export { HiroMark } from '@/components/brand/HiroMark';

const AuthMarketingPanel = () => {
  const { language } = useLanguage();
  const isIt = language === 'it';

  const stats = [
    { value: '−75%', label: isIt ? 'Tempo di screening' : 'Screening time' },
    { value: '3×', label: isIt ? 'Qualità candidati' : 'Candidate quality' },
    { value: '7gg', label: isIt ? 'Trial gratuito' : 'Free trial' },
  ];

  const badges = isIt
    ? ['Progettato per EU AI Act', 'GDPR compliant']
    : ['Built for EU AI Act', 'GDPR compliant'];

  return (
    <div
      className="hidden lg:flex flex-col justify-between p-12 xl:p-16 text-white relative overflow-hidden"
      style={{
        background:
          'linear-gradient(135deg, #0f172a 0%, #1e1b4b 35%, #312e81 65%, #4338ca 100%)',
      }}
    >
      <div
        className="absolute -top-32 -right-32 w-96 h-96 rounded-full opacity-30 blur-3xl"
        style={{ background: 'radial-gradient(circle, #7c3aed, transparent 70%)' }}
      />
      <div
        className="absolute -bottom-40 -left-20 w-[28rem] h-[28rem] rounded-full opacity-20 blur-3xl"
        style={{ background: 'radial-gradient(circle, #a78bfa, transparent 70%)' }}
      />

      <div className="relative flex items-center gap-3">
        <HiroMark className="h-11 w-11" />
        <span className="font-display font-bold text-2xl tracking-tight">HiroMatch</span>
      </div>

      <div className="relative space-y-6 max-w-lg">
        <h1 className="font-display font-bold text-4xl xl:text-5xl leading-[1.1] tracking-tight">
          {isIt ? (
            <>Assumi meglio.<br />Assumi con l&apos;AI.</>
          ) : (
            <>Hire better.<br />Hire with AI.</>
          )}
        </h1>
        <p className="italic text-lg" style={{ color: 'rgba(255,255,255,0.7)' }}>
          AI recruiting, human touch.
        </p>
        <p className="text-base leading-relaxed" style={{ color: 'rgba(255,255,255,0.75)' }}>
          {isIt
            ? 'La prima piattaforma di recruiting AI costruita per le PMI italiane ed europee. Screening intelligente, matching semantico e progettata per l\'EU AI Act — provala gratis per 7 giorni.'
            : 'The first AI recruiting platform built for European SMBs. Smart screening, semantic matching, built for EU AI Act compliance — try it free for 7 days.'}
        </p>

        <div className="grid grid-cols-3 gap-4 pt-6">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col gap-2">
              <div
                className="font-display font-bold text-3xl xl:text-4xl bg-clip-text text-transparent leading-none pb-1"
                style={{ backgroundImage: 'linear-gradient(135deg, #C4B5FD, #FCD34D)' }}
              >
                {s.value}
              </div>
              <div className="text-xs leading-snug" style={{ color: 'rgba(255,255,255,0.6)' }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="relative">
        <div className="flex flex-wrap gap-2">
          {badges.map((b) => (
            <span
              key={b}
              className="text-[11px] px-2.5 py-1 rounded-full border font-medium"
              style={{
                color: 'rgba(255,255,255,0.75)',
                borderColor: 'rgba(255,255,255,0.18)',
                background: 'rgba(255,255,255,0.04)',
              }}
            >
              {b}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuthMarketingPanel;
